
export enum NetWork {
  Testnet = 'testnet',
  Mainnet = 'mainnet',
  STN = 'STN'
}

